import { Button } from '@/components/ui/common/Button'
import * as React from 'react'
import { BalloonResult } from '../BaloonRiskTask'

interface ResultsStageProps {
  totalEarnings: number
  results: BalloonResult[]
  onContinue: () => void
}

export const ResultsStage: React.FC<ResultsStageProps> = ({
  totalEarnings,
  results,
  onContinue
}) => {
  const calculateAveragePumps = () => {
    if (results.length === 0) return 0
    const totalPumps = results.reduce((sum, result) => sum + result.pumps, 0)
    return (totalPumps / results.length).toFixed(1)
  }

  return (
    <div className="flex flex-col items-center gap-6">
      <h2 className="text-center text-xl font-bold">Wyniki</h2>
      <div className="w-full rounded-md bg-[#2bcaca]/10 p-4 text-center">
        <p className="text-sm text-gray-600">Całkowite zarobki:</p>
        <p className="text-3xl font-bold text-indigo-600">{totalEarnings} zł</p>
      </div>
      <div className="w-full overflow-hidden rounded-md border">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left">Balon</th>
              <th className="px-4 py-2 text-center">Pompowania</th>
              <th className="px-4 py-2 text-center">Wynik</th>
              <th className="px-4 py-2 text-right">Zarobek</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {results.map((result) => (
              <tr key={result.balloonNumber}>
                <td className="px-4 py-2">{result.balloonNumber}</td>
                <td className="px-4 py-2 text-center">{result.pumps}</td>
                <td className="px-4 py-2 text-center">
                  {result.popped ? (
                    <span className="text-red-500">Pękł</span>
                  ) : (
                    <span className="text-green-500">Wypłacono</span>
                  )}
                </td>
                <td className="px-4 py-2 text-right">{result.earnings} zł</td>
              </tr>
            ))}
            <tr className="bg-gray-50 font-medium">
              <td className="px-4 py-2">Razem</td>
              <td className="px-4 py-2 text-center"></td>
              <td className="px-4 py-2 text-center"></td>
              <td className="px-4 py-2 text-right">{totalEarnings} zł</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="w-full rounded-md bg-gray-50 p-4 text-center">
        <p className="text-sm text-gray-600">
          Średnia liczba pompowań na balon: {calculateAveragePumps()}
        </p>
      </div>
      <Button className="bg-indigo-600 hover:bg-indigo-700" onClick={onContinue}>
        Przejdź dalej
      </Button>
    </div>
  )
}
